import { RX0004 } from "../rxTypeCode";

export const CLEANUP = "CLEANUP" + RX0004;
export const SET_MODALVISIBLE = "SET_MODALVISIBLE" + RX0004;
export const SET_FUNDID = "SET_FUNDID" + RX0004;
export const SET_MUTUALCREDIT_FUNDID = "SET_MUTUALCREDIT_FUNDID" + RX0004;
export const SET_VIRTUALACCOUNTNUMBER = "SET_VIRTUALACCOUNTNUMBER" + RX0004;
export const SET_VIRTUALACCOUNTNAME = "SET_VIRTUALACCOUNTNAME" + RX0004;
export const SET_ORIGINATOR = "SET_ORIGINATOR" + RX0004;
export const SET_ORIGINATORID = "SET_ORIGINATORID" + RX0004;
export const SET_SETTLEMENTCURRENCY = "SET_SETTLEMENTCURRENCY" + RX0004;
export const SET_SETTLEMENTAMOUNT = "SET_SETTLEMENTAMOUNT" + RX0004;
export const SET_SETTLEMENTAMOUNT_MINUS_FEE = "SET_SETTLEMENTAMOUNT_MINUS_FEE" + RX0004;
export const SET_CLIENTFEEAMOUNT = "SET_CLIENTFEEAMOUNT" + RX0004;
export const SET_VALIDATESTATUS = "SET_VALIDATESTATUS" + RX0004;
export const GET_ORIGINATOR_REQUEST = "GET_ORIGINATOR_REQUEST" + RX0004;
export const GET_ORIGINATOR_SUCCESS = "GET_ORIGINATOR_SUCCESS" + RX0004;
export const GET_ORIGINATOR_FAILURE = "GET_ORIGINATOR_FAILURE" + RX0004;
export const GET_BANKTRANSACTION_LINKS_REQUEST = "GET_BANKTRANSACTION_LINKS_REQUEST" + RX0004;
export const GET_BANKTRANSACTION_LINKS_SUCCESS = "GET_BANKTRANSACTION_LINKS_SUCCESS" + RX0004;
export const GET_BANKTRANSACTION_LINKS_FAILURE = "GET_BANKTRANSACTION_LINKS_FAILURE" + RX0004;


